import InteractionEventName from "../../../../../src/ranj/equalture/workingmemory/data/InteractionEventName";
import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractCommand from "../../app/core/AbstractCommand";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";

export default class PlatformAPICommand extends AbstractCommand {

    /**    
     * @param {PlatformAPIService} platformAPIService 
     */
    constructor(platformAPIService, gameModel, dispatcher) {
        super();
        this._platformAPIService = platformAPIService;
        this._gameModel = gameModel;
        this._dispatcher = dispatcher;

        this.execute = function({ type, params }) {
            switch (type) {
                case PlatformAPIEventType.PROGRESS:
                    platformAPIService.sendProgressEvent(params.progressValue, params.elapsedTime);
                    break;
                case PlatformAPIEventType.INTERACTION:
                    platformAPIService.sendInteractionEvent(params.eventName, params.eventParams, params.elapsedTime);
                    break;
                case PlatformAPIEventType.SAVE_REQUEST:
                    platformAPIService.save(params.state);
                    break;
                case PlatformAPIEventType.POC_ASYNC_EVENT:
                    this.pocAsyncEvent();
                    break;
            }
        }
    }

    // PoC Async Event
    pocAsyncEvent() {
        var delay = parseInt(getURLParameter('delayPocAsync')) || 1000;
        console.log("POC Async - Test Event will be sent in " + delay + " ms.");
        setTimeout(_ => {
            console.log("POC Async - Sending Test Event");
            this._platformAPIService.sendEventAsync('proofOfConceptTestEvent').then(response => {
                console.log("PoC Async - Success Received. Response:");
                console.log(response);
                if(response && response.statusCode) {
                    if(response.statusCode != "201") {
                        console.log("PoC Async - Success Received without statusCode 201");
                        this.pocAsyncInterruptGame(response.statusCode);
                    }else{
                        console.log("PoC Async - Success Received with statusCode 201");
                    }
                } else {
                    this.pocAsyncInterruptGame("unknown");
                }
                
            })
            .catch((error) => {
                console.log("PoC Async - Error Received");
                console.log(error);
                this.pocAsyncInterruptGame("timeout");
            });
        }, delay);
    }

    // PoC Async Event
    pocAsyncInterruptGame(reason) {
        this._dispatcher.dispatch(InteractionEventName.DISABLE_VIEW);
        this._gameModel.stopTimer();
        console.log("POC Async - Sending gameInterrupted event with following payload:")
        var payload = {"status": reason};
        console.log(payload);
        var result = this._platformAPIService.sendGameInterrupted(
            {
                "status": reason
            }
        );
        console.log("POC Async - Return of the gameInterrupted event:");
        console.log(result);
    }
}
